module.exports = __webpack_public_path__ + "img/bj_e.982f02b1.png";